import { useUserCourseProgress } from 'edrolo/domains/bySchoolClass';
import { Progress, Tooltip, enums, utils as u } from 'edrolo-ui';
import { useContext } from 'react';
import { Lesson } from '../../../../../../../types/Assemblage';
import { LinkProps, Link } from 'react-router-dom';
import { ClassContext, UserContext } from 'edrolo/context';
import cx from 'classnames';
import s from '../styles.scss';

interface Props {
  lesson: Lesson;
  url: LinkProps['to'];
}

export const StudentProgress = ({ lesson, url }: Props) => {
  const {
    data: { classId },
  } = useContext(ClassContext);

  const { profile } = useContext(UserContext);
  const { data, loading, error } = useUserCourseProgress(
    profile.user_id,
    +classId
  );

  if (loading || error) {
    return null;
  }

  const chunkViewCount = data.lessons[lesson.id]?.visited_chunks?.length;

  return (
    <Tooltip
      tip={`You have viewed ${chunkViewCount} out of ${lesson.chunks.length} lesson parts`}
    >
      <Link
        to={url}
        className={cx(u.inline, {
          [s.disabled]: lesson.is_coming_soon && !profile.is_staff,
        })}
      >
        <Progress.Circle
          numerator={chunkViewCount}
          denominator={lesson.chunks.length}
          color={enums.ColorHue.BLUE}
          size={enums.Size.LARGE}
          className={u.hiddenSmallOnly}
        />
      </Link>
    </Tooltip>
  );
};
